import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap'; // Import Spinner from react-bootstrap
import usePost from 'core/hooks/api/usePost';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';
import { InputText, DropdownField, InputNumber } from 'components/common/input'; // Import custom input components
import { validateForm } from 'core/utils/validation'; // Import validation function
import useFormHandlers from 'core/hooks/form/useFormHandlers'; // Import useFormHandlers
import { useMediaQuery } from 'react-responsive'; // Import useMediaQuery for responsive handling

const ContactForm = ({ fromWsp, wspUrl, message, product, selectedOption, selectedSize, handleCloseParentModal, setModalIsOpen }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: undefined,
    user_type: '',
    message: message ? message : '',
    fromWsp: fromWsp ? true : false,
    wspUrl: wspUrl ? wspUrl : '',
    product_id: product?.id,
    product_option_id: [
      ...(selectedOption ? [selectedOption?.id] : []),
      ...(selectedSize ? [selectedSize?.id] : [])
    ],
    size: selectedSize ? selectedSize : ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false); // State for loading spinner
  const { postData } = usePost(API_ENDPOINTS.CONTACT);
  const { postData : postDataWebHook } = usePost("https://hook.us2.make.com/cuws2yniahj3z8fn1lkan87l1fsymqd3");
  const { handleChange } = useFormHandlers(setFormData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Set loading state to true
    const validationRules = [
      { field: 'name', method: 'required' },
      { field: 'email', method: 'required' },
      { field: 'phone', method: ['required', 'validPeruPhone'] },
      { field: 'user_type', method: 'required' },
    ];
    const validationErrors = validateForm(formData, validationRules);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false); // Set loading state to false
      return;
    }
    await postDataWebHook({...formData, phone: String(formData.phone)});

    // enviar a contacts
    if (fromWsp === false) {
      await postData({...formData, phone: String(formData.phone)});
    }

    window.open(`${wspUrl}?text=${encodeURIComponent(formData?.message)}`, '_blank');
    setModalIsOpen(true);
    handleCloseParentModal();
    setIsSubmitting(false); // Set loading state to false
  };

  const isMobile = useMediaQuery({ maxWidth: 768 }); // Detect if the device is mobile

  let publicUrl = process.env.PUBLIC_URL + ''

  return (
    <div className="">
      <div className="container mt-3">
        <div className="row">
          <div className="col-lg-12 p-0">
            <div className="ltn__form-box white-bg p-0">
              <form id="form-pro-forma" method="post" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <InputText name="name" placeholder="Ingrese su nombre" onChange={(e) => handleChange('name', e.target.value)} value={formData.name} label="Nombre" error={errors.name} />
                  </div>
                  <div className="col-md-6">
                    <InputText name="email" placeholder="Ingrese su correo electrónico" onChange={(e) => handleChange('email', e.target.value)} value={formData.email} label="Correo Electrónico" error={errors.email} />
                  </div>
                  <div className="col-md-6">
                    {isMobile ? (
                      <InputNumber name="phone" placeholder="945 345 345" onChange={(e) => handleChange('phone', e.value)} value={formData.phone} label="Teléfono" error={errors.phone} />
                    ) : (
                      <InputText name="phone" placeholder="945 345 345" onChange={(e) => handleChange('phone', e.target.value)} value={formData.phone} label="Teléfono" error={errors.phone} />
                    )}
                  </div>
                  <div className="col-md-6">
                    <DropdownField
                      name="user_type"
                      options={[
                        { label: 'Empresarial', value: 'company' },
                        { label: 'Personal', value: 'normal' },
                        { label: 'Institucional', value: 'private' }
                      ]}
                      onChange={(e) => handleChange('user_type', e.value)}
                      value={formData.user_type}
                      placeholder="Seleccione el tipo de servicio"
                      label="Tipo de Servicio"
                      error={errors.user_type}
                    />
                  </div>
                </div>
                <InputText name="message" placeholder="Ingrese su mensaje" onChange={(e) => handleChange('message', e.target.value)} value={formData.message} label="Mensaje" error={errors.message} />
                <div className="btn-wrapper mt-0">
                  <button className={"btn btn-effect-1 text-uppercase " + (fromWsp ? 'theme-btn-wsp' : 'theme-btn-1' )} type="submit" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        Enviando...
                      </>
                    ) : (
                      fromWsp ? 'Contactar por WhatsApp' : 'Cotizar Productos'
                    )}
                  </button>
                </div>
                <p className="form-messege mb-0 mt-20" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;